import State from 'interfaces/state/State';

export const isLoading$ = (state: State) => state.sharedPlaylistTracks.isLoading;
export const list$ = (state: State) => state.sharedPlaylistTracks.list;
export const isError$ = (state: State) => state.sharedPlaylistTracks.isError;
export const currentIndex$ = (state: State) => state.sharedPlaylistTracks.currentIndex;
export const isLoadingZip$ = (state: State) => state.sharedPlaylistTracks.isLoadingZip;
